// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, FormikForm, Icon, SubmitButton, TextField, TextSkeleton, } from '@a-type/ui';
import { graphql, useMutation, useQuery } from '@biscuits/graphql';
import { useState } from 'react';
import { DomainRouteValidation, useAppId } from '../index.js';
import { DeleteDomainRoute } from './DeleteDomainRoute.js';
const domainStatusQuery = graphql(`
	query DomainRouteStatus($input: GetDomainRouteByAppInput!) {
		domainRoute(byApp: $input) {
			id
			status
			domain
		}
	}
`);
const reprovisionDomainMutation = graphql(`
	mutation ReprovisionDomain($id: ID!) {
		reprovisionDomainRoute(id: $id) {
			id
			status
			domain
		}
	}
`);
export function DomainRouteView({ resourceId }) {
    var _a, _b;
    const [open, setOpen] = useState(false);
    const appId = useAppId();
    const [reprovision] = useMutation(reprovisionDomainMutation);
    const { data, refetch } = useQuery(domainStatusQuery, {
        variables: {
            input: {
                appId,
                resourceId,
            },
        },
        onCompleted: async (data) => {
            // auto-fix if cert was not provisioned
            const route = data === null || data === void 0 ? void 0 : data.domainRoute;
            if (route && route.status === 'UNPROVISIONED') {
                console.warn(`Reprovisioning domain ${route.domain}`);
                await reprovision({
                    variables: { id: route.id },
                });
            }
        },
    });
    if (data && data.domainRoute === null) {
        return (_jsx(DomainRouteRegister, { resourceId: resourceId, onSubmit: async () => {
                await refetch();
                setOpen(true);
            } }));
    }
    const domain = (_a = data === null || data === void 0 ? void 0 : data.domainRoute) === null || _a === void 0 ? void 0 : _a.domain;
    const status = (_b = data === null || data === void 0 ? void 0 : data.domainRoute) === null || _b === void 0 ? void 0 : _b.status;
    return (_jsxs(Dialog, { open: open, onOpenChange: setOpen, children: [_jsx(Dialog.Trigger, { asChild: true, children: _jsxs(Button, { color: status === 'READY' ? 'accent' : 'primary', emphasis: status === 'READY' ? 'primary' : 'default', className: "justify-between", children: [domain !== null && domain !== void 0 ? domain : _jsx(TextSkeleton, { maxLength: 30 }), _jsx(Icon, { name: status === 'READY' ? 'check' : 'warning' })] }) }), _jsxs(Dialog.Content, { className: "flex flex-col gap-md", children: [_jsx(DomainRouteValidation, { resourceId: resourceId }), (data === null || data === void 0 ? void 0 : data.domainRoute) && (_jsx(DeleteDomainRoute, { domainRouteId: data.domainRoute.id, onDelete: refetch, className: "self-start" })), _jsx(Dialog.Actions, { children: _jsx(Dialog.Close, { asChild: true, children: _jsx(Button, { children: "Close" }) }) })] })] }));
}
const domainRegisterMutation = graphql(`
	mutation registerDomain($input: CreateDomainRouteInput!) {
		createDomainRoute(input: $input) {
			domainRoute {
				id
			}
		}
	}
`);
function DomainRouteRegister({ resourceId, onSubmit, }) {
    const appId = useAppId();
    const [mutate] = useMutation(domainRegisterMutation, {
        onCompleted: () => {
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        },
    });
    return (_jsx(FormikForm, { initialValues: {
            domain: '',
        }, onSubmit: async (values, bag) => {
            let domain = values.domain;
            if (protocolMatch.test(domain)) {
                domain = domain.replace(protocolMatch, '');
            }
            if (!hostnameMatch.test(domain)) {
                console.error('Invalid domain', domain);
                bag.setFieldError('domain', 'Invalid domain');
                return;
            }
            await mutate({
                variables: {
                    input: {
                        appId,
                        resourceId,
                        domain,
                    },
                },
            });
        }, children: _jsxs(Box, { d: "row", gap: true, items: "end", full: true, children: [_jsx(TextField, { placeholder: "blog.yourdomain.club", name: "domain", label: "Register a domain", className: "flex-1" }), _jsx(SubmitButton, { emphasis: "primary", children: _jsx(Button.Icon, { children: _jsx(Icon, { name: "arrowRight" }) }) })] }) }));
}
const hostnameMatch = /[a-z0-9-]+\.[a-z0-9-]+/;
const protocolMatch = /^(https?:\/\/)?/;
//# sourceMappingURL=DomainRouteView.js.map